import React from 'react';
import { 
  Clock, 
  CheckCircle, 
  Settings, 
  Truck, 
  Package, 
  XCircle,
  TrendingUp
} from 'lucide-react';

const StatusBadge = ({ status, size = 'default', showIcon = true, className = '' }) => {
  const statusConfig = {
    'pending': {
      label: 'En attente',
      color: 'bg-yellow-500',
      textColor: 'text-yellow-900',
      borderColor: 'border-yellow-400',
      icon: Clock,
      bgGradient: 'from-yellow-400 to-yellow-500',
      shadow: 'shadow-yellow-500/25'
    },
    'confirmed': {
      label: 'Confirmée',
      color: 'bg-blue-500',
      textColor: 'text-white',
      borderColor: 'border-blue-400',
      icon: CheckCircle,
      bgGradient: 'from-blue-400 to-blue-500',
      shadow: 'shadow-blue-500/25'
    },
    'processing': {
      label: 'En traitement',
      color: 'bg-purple-500',
      textColor: 'text-white',
      borderColor: 'border-purple-400',
      icon: Settings,
      bgGradient: 'from-purple-400 to-purple-500',
      shadow: 'shadow-purple-500/25'
    },
    'shipped': {
      label: 'Expédiée',
      color: 'bg-indigo-500',
      textColor: 'text-white',
      borderColor: 'border-indigo-400',
      icon: Truck,
      bgGradient: 'from-indigo-400 to-indigo-500',
      shadow: 'shadow-indigo-500/25'
    },
    'delivered': {
      label: 'Livrée',
      color: 'bg-green-500',
      textColor: 'text-white',
      borderColor: 'border-green-400',
      icon: Package,
      bgGradient: 'from-green-400 to-green-500',
      shadow: 'shadow-green-500/25'
    },
    'cancelled': {
      label: 'Annulée',
      color: 'bg-red-500',
      textColor: 'text-white',
      borderColor: 'border-red-400',
      icon: XCircle,
      bgGradient: 'from-red-400 to-red-500',
      shadow: 'shadow-red-500/25'
    }
  };

  const config = statusConfig[status] || statusConfig['pending'];
  const IconComponent = config.icon;

  const sizeClasses = {
    xsmall: 'px-1.5 py-0.5 text-xs',
    small: 'px-2 py-1 text-xs',
    default: 'px-3 py-1.5 text-sm',
    large: 'px-4 py-2 text-base'
  };

  return (
    <div className={`
      inline-flex items-center gap-2 rounded-full font-medium transition-all duration-300
      bg-gradient-to-r ${config.bgGradient} ${config.textColor}
      border-2 ${config.borderColor} ${config.shadow}
      hover:scale-105 hover:shadow-lg
      ${sizeClasses[size]}
      ${className}
    `}>
             {showIcon && (
         <IconComponent 
           size={size === 'xsmall' ? 12 : size === 'small' ? 14 : size === 'large' ? 20 : 16} 
           className="animate-pulse"
         />
       )}
      <span className="font-semibold">{config.label}</span>
      
             {/* Animated progress indicator for processing status */}
       {status === 'processing' && (
         <div className="ml-1">
           <div className="flex space-x-1">
             <div className="w-1 h-1 bg-current rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
             <div className="w-1 h-1 bg-current rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
             <div className="w-1 h-1 bg-current rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
           </div>
         </div>
       )}
       
       {/* Animated truck for shipped status */}
       {status === 'shipped' && (
         <div className="ml-1 animate-bounce">
           <Truck size={size === 'xsmall' ? 10 : size === 'small' ? 12 : size === 'large' ? 16 : 14} />
         </div>
       )}
       
       {/* Success checkmark for delivered status */}
       {status === 'delivered' && (
         <div className="ml-1 animate-pulse">
           <CheckCircle size={size === 'xsmall' ? 10 : size === 'small' ? 12 : size === 'large' ? 16 : 14} />
         </div>
       )}
    </div>
  );
};

export default StatusBadge;
